import React, { useState } from "react";
import { decodeHtml } from "../../assests/extention/commonfunction";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import CloudStorage from "../../CloudStorage/CloudStorage";
import { useDispatch } from "react-redux";
import { sendhireRequest } from "../../redux/job/action";
import { descriptionvalidation } from "./commonvalidation";

export default function HireRequestModel({ posts, setModal1, modal1, proid }) {
  const [designation, setDesignation] = useState("");
  const [loading, setLoading] = useState(false);

  const validationSchema = Yup.object().shape({
    description: descriptionvalidation,
  });

  const dispatch = useDispatch();

  const handleSubmit = (values) => {
    const data = {
      ...values,
      type: "3",
      id: proid,
      message: designation,
      status: "23",
    };
    setLoading(true);
    dispatch(sendhireRequest(data)).then(() => {
      setLoading(false);
      setModal1(false);
    });
  };

  const initialValues = {
    description: "",
  };

  return (
    <Modal isOpen={modal1} toggle={() => setModal1(!modal1)}>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
        enableReinitialize
      >
        {({ setFieldValue }) => (
          <Form>
            <button
              onClick={() => setModal1(false)}
              className="btn close-button d-block"
            >
              <img
                src={`${CloudStorage.cloudurl}/Assets/Images/common/close-icon.svg`}
                alt=""
              />
            </button>
            <ModalBody>
              <h4>Edit Description</h4>
              <div className="form-group">
                <label>Enter Description</label>
                <Field
                  as="textarea"
                  style={{ height: "100px" }}
                  value={decodeHtml(designation)}
                  name="description"
                  placeholder="Your Description"
                  className="form-control"
                  onChange={(e) => {
                    setDesignation(e.target.value);
                    setFieldValue("description", e.target.value);
                  }}
                />
                <ErrorMessage
                  name="description"
                  component="div"
                  className="error"
                />
              </div>
            </ModalBody>
            <ModalFooter>
              <Button color="primary" type="submit" disabled={loading}>
                {loading ? "Sending Proposal..." : "Send Proposal"}
              </Button>
            </ModalFooter>
          </Form>
        )}
      </Formik>
    </Modal>
  );
}

// PREEMPTIVE HMR BURST
